import { FC, Fragment } from 'react'
import { AppModule } from '@core/modules/app/app.module'
import { TDomain } from '@core/modules/domains/domains'
import { CustomTooltip } from '@atbay/component-lib'
import CircleIndicator from '@components/circle-indicator'
import Typography from '@/ui/components/typography'
import { TTheme, useCustomTheme } from '@/core/theme'
import {
    DomainContainer,
    DomainUrlWrapper,
} from '@routes/settings/routes/account/domain/domain.styles'
import { CloseIcon } from '@atbay/icons'

interface DomainProps {
    domain: TDomain
    domainsInProcess: string[]
    handleOnDeleteDomainClick: (id: string) => void
}

const Domain: FC<DomainProps> = ({
    domain,
    domainsInProcess,
    handleOnDeleteDomainClick,
}) => {
    const theme = useCustomTheme() as TTheme
    const { id, domain_url, status, inProcess } = domain
    const { scanInProgress } = AppModule.useStore()

    return (
        <DomainContainer
            key={id}
            className={'domain-block'}
            data-testid="domain-block"
        >
            <DomainUrlWrapper>
                <CustomTooltip title={domain_url} placement="top">
                    <Typography
                        className="domain-url"
                        variant="s-regular"
                        color={theme.colors.greys[800]}
                    >
                        {domain_url}
                    </Typography>
                </CustomTooltip>
            </DomainUrlWrapper>
            {status === 'UserApproved' && (
                <Fragment>
                    {domainsInProcess?.includes(id) || inProcess ? (
                        <CircleIndicator size={12} width={2} loading={true} />
                    ) : (
                        <span
                            className="close-icon"
                            data-testid="remove-domain"
                        >
                            {!scanInProgress && (
                                <CloseIcon
                                    onClick={() =>
                                        handleOnDeleteDomainClick(id)
                                    }
                                />
                            )}
                        </span>
                    )}
                </Fragment>
            )}
        </DomainContainer>
    )
}

export default Domain
